import React from 'react';
import { motion } from 'framer-motion';
export const PhulkariBorder = ({
  className = ''
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 100 10" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-276">
    <pattern id="phulkari" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-277">
      <path d="M5 0L10 5L5 10L0 5Z" fill="currentColor" opacity="0.8" data-id="element-278" />
      <path d="M5 2L8 5L5 8L2 5Z" fill="var(--color-navy)" opacity="0.5" data-id="element-279" />
    </pattern>
    <rect width="100%" height="100%" fill="url(#phulkari)" data-id="element-280" />
  </svg>;
export const ArchMotif = ({
  className = ''
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-281">
    <path d="M10 120V50C10 27.9086 27.9086 10 50 10C72.0914 10 90 27.9086 90 50V120" stroke="currentColor" strokeWidth="2" strokeOpacity="0.3" data-id="element-282" />
    <path d="M20 120V50C20 33.4315 33.4315 20 50 20C66.5685 20 80 33.4315 80 50V120" stroke="currentColor" strokeWidth="1" strokeOpacity="0.2" data-id="element-283" />
    <circle cx="50" cy="50" r="4" fill="currentColor" opacity="0.5" data-id="element-284" />
  </svg>;
export const KesariDot = ({
  className = ''
}: {
  className?: string;
}) => <motion.div initial={{
  scale: 0.8,
  opacity: 0.5
}} animate={{
  scale: [0.8, 1.2, 0.8],
  opacity: [0.5, 1, 0.5]
}} transition={{
  duration: 3,
  repeat: Infinity,
  ease: 'easeInOut'
}} className={`w-2 h-2 rounded-full bg-kesari shadow-[0_0_8px_rgba(212,118,60,0.6)] ${className}`} data-id="element-285" />;
export const GurmukhiWatermark = ({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) => <div className={`font-gurmukhiSerif absolute pointer-events-none select-none opacity-[0.03] text-[15rem] leading-none whitespace-nowrap ${className}`} data-id="element-286">
    {text}
  </div>;